/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RuoloUtenteDto } from '../../models/ruolo-utente-dto';

export interface ApiAuthRuoloUtenteListGet$Params {
    /**
     * Id dell'utente per cui caricare i ruoli
     */
    utenteId: number;
}

export function apiAuthRuoloUtenteListGet(
    http: HttpClient,
    rootUrl: string,
    params: ApiAuthRuoloUtenteListGet$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<Array<RuoloUtenteDto>>> {
    const rb = new RequestBuilder(rootUrl, apiAuthRuoloUtenteListGet.PATH, 'get');
    if (params) {
        rb.query('utenteId', params.utenteId, {});
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<Array<RuoloUtenteDto>>;
        }),
    );
}

apiAuthRuoloUtenteListGet.PATH = '/api/auth/ruolo-utente-list';
